/**
 * NotFoundPage - página 404 personalizada
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/brand";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center px-4 text-center bg-hero-radial-light"
            data-testid="not-found-page"
        >
            <Link to="/" className="flex items-center gap-2 mb-8">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#0B0B10] overflow-hidden">
                    <img src={LOGO_URL} alt="MeSafa" className="h-10 w-10 object-contain" />
                </span>
                <span className="font-display font-bold text-xl tracking-tight">
                    <span className="text-[#A78BFA]">me</span>
                    <span>Safa</span>
                </span>
            </Link>

            {/* Número 404 estilizado */}
            <div className="relative mb-6 select-none">
                <span
                    className="font-display font-black text-[8rem] sm:text-[12rem] leading-none"
                    style={{
                        background: "linear-gradient(135deg, #6B21D9 0%, #A78BFA 50%, #2DD4BF 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }}
                >
                    404
                </span>
            </div>

            <h1 className="font-display text-2xl sm:text-3xl font-semibold mb-3">
                Página não encontrada
            </h1>
            <p className="text-muted-foreground max-w-md mb-8">
                A página que está a procurar não existe ou foi movida. Verifique o endereço ou volte à página inicial.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
                <Button asChild className="btn-grad-purple text-white gap-2">
                    <Link to="/">
                        <Home className="h-4 w-4" /> Ir para a página inicial
                    </Link>
                </Button>
                <Button asChild variant="outline" className="gap-2">
                    <Link to="/painel">
                        <ArrowLeft className="h-4 w-4" /> Ir para o painel
                    </Link>
                </Button>
            </div>
        </div>
    );
}
